/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\FieldWithReset.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the httpServer module.
----------------------------------------------------------------*/


import React from 'react';
import { RotateCcw } from 'lucide-react';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';

interface FieldWithResetProps {
    children: React.ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    currentValue: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    defaultValue: any;
    onReset?: () => void;
    resetTooltip?: string;
    className?: string;
}

export function FieldWithReset({
    children,
    currentValue,
    defaultValue,
    onReset,
    resetTooltip = 'Reset to default',
    className = ''
}: FieldWithResetProps) {
    // Compare values (handle different types)
    const isModified = JSON.stringify(currentValue) !== JSON.stringify(defaultValue);

    return (
        <div className={`relative flex items-center gap-1 ${className}`}>
            <div className="flex-1">
                {children}
            </div>
            {isModified && onReset && (
                <SimpleTooltip content={resetTooltip} position="top">
                    <button
                        type="button"
                        onClick={onReset}
                        className="p-1 rounded hover:bg-primary/10 text-primary/60 hover:text-primary transition-colors"
                    >
                        <RotateCcw className="h-3.5 w-3.5" />
                    </button>
                </SimpleTooltip>
            )}
        </div>
    );
}
